import { replace } from 'react-router-redux';

import apiSubmitDonation from '../../utils/donation/donationApi';

import {
    ACTION_COMPLETED_LOCAL_REP,
    EMAIL_COLLECTED,
    IS_NEXT_ACTION_TRANSITION,
    SET_END_USER_ID,
    SHOW_NEXT_ACTION_ANIMATION,
    onFinishMultiAction
} from '../Widget/actions';

import donationAnimationJsonDesktop from '../../components/Donation/DonationSubmittingAnimation_Desktop.json';
import donationAnimationJsonMobile from '../../components/Donation/DonationSubmittingAnimation_Mobile.json';

let lottie;
import('lottie-web').then(l => (lottie = l));

export const SELECT_AMOUNT = 'SELECT_AMOUNT';
export const DONATE_MORE = 'DONATE_MORE';
export const CUSTOM_AMOUNT_CHANGED = 'CUSTOM_AMOUNT_CHANGED';
export const DONATION_SUCCESS = 'DONATION_SUCCESS';
export const DONATION_DONE = 'DONATION_DONE';
export const DONATION_SUBMITTING = 'DONATION_SUBMITTING';
export const SET_SUCCESS_INFO = 'SET_SUCCESS_INFO';
export const DONATION_SUBMITTING_ERROR = 'DONATION_SUBMITTING_ERROR';
export const MOBILE_GO_WIZARD_STEP = 'MOBILE_GO_WIZARD_STEP';
export const DONATION_GO_BACK_TO_AMOUNT = 'DONATION_GO_BACK_TO_AMOUNT';

let toasterTimeout = null;
let anim = null;
let framePause = 93;

export const loadAnim = (container, isMobileResolution) => {
    anim = lottie.loadAnimation({
        container: container,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        animationData: isMobileResolution
            ? donationAnimationJsonMobile
            : donationAnimationJsonDesktop
    });
    const startFrame = 20;
    anim.playSegments([startFrame, framePause], true);
};

export const selectAmount = amount => dispatch => {
    dispatch({
        type: SELECT_AMOUNT,
        payload: Number.isInteger(amount) ? amount : parseInt(amount, 10)
    });

    dispatch({
        type: DONATE_MORE,
        payload: false
    });

    dispatch({
        type: SHOW_NEXT_ACTION_ANIMATION
    });

    dispatch({
        type: IS_NEXT_ACTION_TRANSITION,
        payload: true
    });

    dispatch(replace('/donation/details'));
};

export const donateMore = isEnabled => dispatch => {
    dispatch({
        type: DONATE_MORE,
        payload: isEnabled
    });
};

export const onCustomAmountChanged = (event, values) => dispatch => {
    dispatch({
        type: CUSTOM_AMOUNT_CHANGED,
        payload: values.value
    });
};

export const onBackToAmount = () => dispatch => {
    dispatch({
        type: DONATION_GO_BACK_TO_AMOUNT
    });

    dispatch(replace('/donation'));
};

export const mobileGoWizardStep = step => dispatch => {
    dispatch({
        type: MOBILE_GO_WIZARD_STEP,
        payload: step
    });
};

function getTimeFrom(fromDate) {
    return (new Date() - fromDate) / 1000;
}

export const submitDonation = (
    apiRequestData,
    values,
    amount,
    paymentMethod,
    selectedAmountTime,
    isMultiActionsCard,
    actionIdentifier,
    feedbackText,
    partnerName,
    skipEndCard
) => dispatch => {
    dispatch({
        type: DONATION_SUBMITTING,
        payload: true
    });

    let actionCompleteTime = getTimeFrom(selectedAmountTime);
    apiSubmitDonation(apiRequestData, {
        ...values,
        amount,
        actionCompleteTime,
        paymentMethod,
        feedbackText,
        partnerName
    })
        .then(data => {
            if (anim && !isMultiActionsCard) {
                anim.playSegments([framePause, 144], true);
            }
            setTimeout(() => {
                dispatch({
                    type: SET_END_USER_ID,
                    payload: data.endUserId
                });

                dispatch({
                    type: DONATION_SUCCESS,
                    payload: { ...data, actionIdentifier }
                });

                dispatch({
                    type: SET_SUCCESS_INFO,
                    payload: {
                        feedbackText,
                        partnerName
                    }
                });

                dispatch({
                    type: ACTION_COMPLETED_LOCAL_REP
                });

                if (values.getUpdates) {
                    dispatch({
                        type: EMAIL_COLLECTED,
                        payload: true
                    });
                }

                if (isMultiActionsCard) {
                    onFinishMultiAction(actionIdentifier)(dispatch);
                } else if (!skipEndCard) {
                    dispatch(replace('/donation/success'));
                }

                setTimeout(() => {
                    dispatch({
                        type: DONATION_SUBMITTING,
                        payload: false
                    });
                }, 700);
            }, 1500);
        })
        .catch(errorMessage => {
            dispatch({
                type: DONATION_SUBMITTING_ERROR,
                payload: errorMessage
            });

            if (toasterTimeout != null) {
                clearTimeout(toasterTimeout);
                toasterTimeout = null;
            }

            toasterTimeout = setTimeout(() => {
                toasterTimeout = null;
                dispatch({
                    type: DONATION_SUBMITTING_ERROR,
                    payload: null
                });
            }, 5000);

            dispatch({
                type: DONATION_SUBMITTING,
                payload: false
            });
        });
};



// WEBPACK FOOTER //
// ./src/containers/Donation/actions.js